import { ONE_SECOND } from '@gem/services/date-service';

import imgStub from './assets/img-stub.png';
import { IStorageSessionCredentials } from './types';

interface IRemoteStorageConfiguration {
  isConfigured: boolean;
  getCredentialsRequest?(): Promise<IStorageSessionCredentials | null>;
  credentialsUpdateInterval: number;
  fileRequestRetriesCount: number;
  imageStubSrc: string;
}

interface IConfigureRemoteStorageParams extends Omit<IRemoteStorageConfiguration, 'isConfigured'> {}

export const remoteStorageConfiguration: IRemoteStorageConfiguration = {
  isConfigured: false,
  fileRequestRetriesCount: 1,
  credentialsUpdateInterval: 30 * ONE_SECOND,
  imageStubSrc: imgStub,
};

export function configureRemoteStorage(
  configuration: Partial<IConfigureRemoteStorageParams>
): void {
  remoteStorageConfiguration.isConfigured = true;

  if (configuration.fileRequestRetriesCount) {
    remoteStorageConfiguration.fileRequestRetriesCount = configuration.fileRequestRetriesCount;
  }

  if (configuration.getCredentialsRequest) {
    remoteStorageConfiguration.getCredentialsRequest = configuration.getCredentialsRequest;
  }
}
